import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Store} from './store';

@Injectable()
export class StoreService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('stores?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('stores/' + _id).map((response: Response) => response.json());
  }
  getAllStores() {
    return this.http.get('stores/all').map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('stores/trashed/' + _id).map((response: Response) => response.json());
  }
  checkfoundbranch(_id: any = 0,_branch: string) {
    return this.http.get('stores/checkfound/' + _id + "/" + _branch).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('stores/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(store: Store) {
    return this.http.post('stores', store).map((response: Response) => response.json());
  }

  update(store: Store) {
    return this.http.put('stores/' + store.id, store).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('stores/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/stores/store.service.ts